module.exports = __webpack_public_path__ + "static/media/similar_cuboid.b1593299.jpg";